<template>
  <div id="app">
    <v-header :inputName='Name'></v-header>

    <v-serch :pickerValueArray="pickerValueArray" @search="search" style="height: 75px;"></v-serch>
    <v-massage ref="massage" style="width: 1280px;padding-top: 0;"></v-massage>
    <v-crumbs @search="searchMajor" v-if="typename == 'majorscore'&&showcrumbs"></v-crumbs>
    <div class="container tablecon">
      <!-- <yaunfenHeader :tianbaoType="tianbaoType" :typename="typename" :guding="guding"></yaunfenHeader> -->
      <newgkmajorHeader :guding="guding" :jhYear="jhYear" :showtype="typename"></newgkmajorHeader>
      <div class="three" id="yuanshu2">
        <newgkmajorInfo :ref="`${tianbaoType==2?item.dataid:item.id}`" :item="item" :scoreyear="scoreYear"
          v-for="(item, index) in data" @select="openMajor" :key="index" :index="index" :showtype="typename" :showrate="false">
        </newgkmajorInfo>

        <!-- <div class="three_for" v-for="(item, index1) in data" :key="'index'+index1">
          <div class="Cont Cont1" :style="{width:rlist[0]+'%'}">
            <div class="Cont_TP">
              <img :src="($resourcesUrl+'/college/'+`${item.obj.college_id}`+'/'+`${item.obj.college_icon}`)" alt="">
              <p v-if="item.obj.college_code!=null&&item.obj.college_code!=''&&$utils.getlocalStorage('showcode')">代码:{{item.obj.college_code}}</p>
            </div>
            <div class="Cont_Nr">
              <p>
                <router-link tag="a" target="_blank" :to="'/xyzy_jianjie?num=0&id='+item.obj.college_id">
                  {{ item.obj.college_name }}
                </router-link>
              </p>
              <p v-if="$utils.showflag(item.obj.college_info)" style="font-size: 14px;color: #c0c4cc;">
                {{ item.obj.college_info }}
              </p>
              <div class="Cont_Card" :style="{marginTop:$utils.showflag(item.obj.college_info)?'5px':'12px'}"
                v-if="item.obj.college_level!=null&&item.obj.college_level!=''">
                <span>{{ item.obj.college_level.replace(/,/g,'、') }}</span>
              </div>
              <div class="Cont_Card" :style="{marginTop:item.college!=null?'5px':'12px'}"
                v-if="item.college!=null">
                <icollege :item="item"></icollege>
              </div>
            </div>
          </div>
          <div class="Cont Cont2" :style="{width:rlist[1]+'%'}">
            <p>{{ item.obj.college_subject }}</p>
          </div>
          <div class="Cont Cont3" :style="{width:rlist[2]+'%'}">
            <p>{{AREA_OBJ[item.obj.college_area]}}</p>
          </div>
          <div class="Cont Cont4" :style="{width:rlist[3]+'%'}">
            <p>{{ item.obj.college_subjection }}</p>
          </div>
          <div class="Cont Cont5" :style="{width:rlist[4]+'%'}">
            <p>{{item.obj.college_nature == 1?'公立':'民办'}}</p>
          </div>
          <div class="Cont Cont6" v-if="tianbaoType!=1&&typename == 'collegescore'" :style="{width:rlist[5]+'%'}">
            <div class="Cont2_top1" style="text-align: center;">
              <p style="margin-bottom: 10px;" v-if="tianbaoType == 2">分组: <span
                  style="color: #FF513E;">{{item.obj.group_name}}</span></p>
              <p class="btn" @click="openMajor(item.obj.plan_id,item.obj.college_id,item.obj.group_name)">查看专业</p>
            </div>
          </div>
          <div class="Cont Cont6" :style="{width:rlist[5]+'%'}"
            v-if="tianbaoType==1||typename == 'majorscore'">
            <div class="Cont2_top">
              <div style="width: 100%;" v-if="item.obj.major_code!=null&&item.obj.major_code!=''">
                <span v-if="tianbaoType == 2">分组：<span style="color: #FF513E;">{{item.obj.group_name}}</span></span>
                <span v-if="$utils.getlocalStorage('showcode')">代码：<span style="color: #FF513E;">{{item.obj.major_code}}</span></span>
              </div>
              <p style="color: #FF513E;">
              <router-link tag="a" target="_blank" :to="'/zyxq_zhuanyejieshao?id='+item.obj.major_id">
                {{ item.obj.major_name }}
              </router-link>
			  <p style="margin-right:20px;color:#F53824;" v-if="item.obj.tuition!=null">
			    学费 : {{item.obj.tuition}}
			  </p>
              </p>
              <div class="Cont2_bot" v-if="item.major!=null">
                <imajor :item="item"></imajor>
              </div>
              <div class="Cont2_bot" v-if="item.obj.major_info!=null&&item.obj.major_info!=''">
                <el-tooltip :content="item.obj.major_info" effect="dark" placement="right">
                  <div style="height: auto;width: auto; max-width: 350px;color: #ffffff;" slot="content">
                    {{ item.obj.major_info}}
                  </div>
                  <p style="font-size: 12px;color: #999999;">
                    {{ item.obj.major_info.length>30?item.obj.major_info.substring(0,30)+'...':item.obj.major_info }}
                  </p>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="Cont Cont10" v-if="tianbaoType!=0">
            <p>{{ $utils.getZyShowXuanKe(item.obj)  }}</p>
          </div>
          <div class="Cont Cont7" :style="{width:rlist[6]+'%'}">
            <p>{{ showinfo(item.obj.plan_num) }}</p>
          </div>
          <div class="Cont Cont8" :style="{width:rlist[7]+'%'}">
            <div v-for="(info, index2) in getscore(item.list,scoreYear)" :key="'index2'+index2" class="scoreInfo">
              <div class="Cont8_B">{{ showinfo(info.scoreYear) }}</div>
              <div class="Cont8_B">{{ showinfo(info.scorePlanNum) }}</div>
              <div class="Cont8_B">{{ showinfo(info.scoreMin) }}</div>
              <div class="Cont8_B">{{ showinfo(info.scoreMinRank) }}</div>
              <div class="Cont8_B">{{ showinfo(info.scoreXiancha) }}</div>
            </div>
          </div>
          <div class="Cont Cont9" :style="{width:rlist[8]+'%'}">
            <div
              :class="{Cont9_A:!userCang.indexOf(item.obj.plan_id)!=-1,Cont9_B:userCang.indexOf(item.obj.plan_id)!=-1}"
              @click="guanzhu(item.obj.plan_id,userCang.indexOf(item.obj.plan_id)!=-1,typename)">
              <p>{{userCang.indexOf(item.obj.plan_id)!=-1?'已关注':'+ 关注'}}</p>
            </div>
          </div>
        </div> -->
        <loadData :loadding="loadding" :noMore="noMore" :total="pages" message="该筛选条件下无相关数据，请修改对应批次后再查询"></loadData>

      </div>
    </div>
    <item7></item7>
    <zuoxuanfu1></zuoxuanfu1>
    <zyCollegeMajor v-if="isTrue" :obj="selectItemObj" showtype="majorscore" datatype="cs" :jhflag="false"
      :querykey="message" @close="isTrue = false"></zyCollegeMajor>
    <!-- <div class="container">
      <div class="mask" v-if="isTrue">
        <div class="maskA">
          <div class="maskAA">
            <p>专业分数</p>
            <img @click="zzcB()" src="../../src/assets/img/cha.png" />
          </div>
          <div class="ANAN">
            <div class="two_A" style="position: fixed;margin-left: 20px;">
              <div class="T_title1_A">专业名称</div>
              <div class="T_title8_A">
                <div class="T_title8bot_A">
                  <div>年份</div>
                  <div>录取数</div>
                  <div>最低分</div>
                  <div>位次</div>
                  <div>线差</div>
                </div>
              </div>
              <div class="T_title9_A">操作</div>
            </div>
            <div class="three_A" style="margin-top: 50px;">
              <div class="three_for_A" v-for="(item, index4) in majorList" :key="'index4'+index4">
                <div class="Cont_A Cont1_A">
                  <div class="Cont_Nr_A">
                    <span v-if="getempty(item.obj.major_code)!='--'&&$utils.getlocalStorage('showcode')"
                    style="color: #FF513E;"
                    >专业代码 : {{ item.obj.major_code }}
                    <span style="margin-left: 50px;">{{item.obj.plan_year}}年计划 : {{ item.obj.plan_num }}</span>
                    </span>
                    <h3 style="margin-top: 10px;">{{item.obj.major_name}}</h3>
					<p style="margin-right:20px;color:#F53824;">
					  学费 : {{item.obj.tuition}}
					</p>
                    <imajor :item="item"></imajor>

                    <el-tooltip effect="dark" placement="right" v-if="$utils.showflag(item.obj.major_info)">
                      <div style="height: auto;width: auto; max-width: 350px;color: #ffffff;" slot="content">
                        {{ item.obj.major_info}}
                      </div>
                      <p style="font-size: 14px;">
                        {{ item.obj.major_info.length>45?item.obj.major_info.substring(0,45)+'.....':item.obj.major_info }}
                      </p>
                    </el-tooltip>
                  </div>
                </div>
                <div class="Cont_A Cont8_S">
                  <div class="Cont8_A Cont8_AA" v-for="(data, index6) in getscore(item.list,majorScoreYear)" :key="'index6'+index6">
                    <div class="Cont8_B">{{ showinfo(data.scoreYear) }}</div>
                    <div class="Cont8_B">{{ showinfo(data.scorePlanNum) }}</div>
                    <div class="Cont8_B">{{ showinfo(data.scoreMin) }}</div>
                    <div class="Cont8_B">{{ showinfo(data.scoreMinRank) }}</div>
                    <div class="Cont8_B">{{ showinfo(data.scoreXiancha) }}</div>
                  </div>
                </div>
                <div class="Cont_A Cont9_S">
                  <div
                    :class="{Cont9_AAA:!majorcangList.indexOf(item.obj.plan_id)!=-1,Cont9_BBB:majorcangList.indexOf(item.obj.plan_id)!=-1}"
                    @click="guanzhu(item.obj.plan_id,majorcangList.indexOf(item.obj.plan_id)!=-1,'majorscore')">
                    <p>{{majorcangList.indexOf(item.obj.plan_id)!=-1?'已关注':'+ 关注'}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
  import zuoxuanfu1 from '../components/zuoxuanfu1.vue'
  import vSerch from "../components/vSerchfen.vue";
  import vHeader from "../components/vHeader.vue";
  import item7 from "../components/item7.vue";
  import icollege from "../components/icollege.vue";
  import imajor from "../components/imajor.vue";
  import vMassage from "../components/vMassage.vue";
  import vCrumbs from "../components/vCrumbs.vue";
  import newgaokao750 from "../../css/newgaokao750.css"
  import yaunfenHeader from '../components/tianbaoHeader/yuanfenHeader.vue'
  import newgkmajorHeader from '../components/tianbaoHeader/newgkmajorHeader.vue'
  import newgkmajorInfo from '../components/tianbaoInfo/newgkmajorInfo.vue'
  import zyCollegeMajor from '../components/zyCollegeMajor.vue'
   import loadData from '../components/loadData.vue'
  export default {
    props: [],
    components: {
      vSerch,
      vHeader,
      item7,
      icollege,
      imajor,
      vCrumbs,
      newgaokao750,
      yaunfenHeader,
      zuoxuanfu1,
      loadData,
      vMassage,
      newgkmajorHeader,
      newgkmajorInfo,
      zyCollegeMajor
    },
    data() {
      return {
        // 导航选中
        Name: 0,
        guding: false,
        // 用来标识遮罩层显示与隐藏的
        isTrue: false,
        pageSize: 10,
        pageNum: 1,
        pages: 0,
        loadMoreText: "加载中...",
        showLoadMore: false,
        typename: 'collegescore',
        batch: "",
        pickerValueArray: [],
        list: [],
        data: [],
        collegeName: "",
        majorName: '',
        c: 0,
        xianshi: false,
        AREA_OBJ: this.$utils.getlocalStorage("AREA_OBJ"),
        scoreInfo: this.$utils.getlocalStorage("scoreInfo"),

        bb1: false,
        jhYear:2026,
        themeColor: '#F53824',
        mode: '',
        pickerValueDefault: [],
        loadding: false,
        noMore:false,
        userCang: [],
        majorcangList: [],
        tianbaoType: this.$utils.getlocalStorage("tianbaoType"),
        collegeAreas: "",
        collegeSubjection: '',
        collegeSubject: '',
        collegeLevel: '',
        majorInfo: '',
        collegeNature: '',
        majorList: [],
        showcrumbs: false,
        rlist: [],
        scoreYear:2022,
        majorScoreYear:2022,
        message: '',

      };
    },
    computed: {},
    mounted() {
      window.addEventListener('scroll', this.handleScrollx, true)
      this.getprovincialTable();
    },
    created() {
      // this.$nextTick(() => {
      //   document.oncontextmenu = new Function("event.returnValue=false"); // 禁用右键
      //   document.onselectstart = new Function("event.returnValue=false"); // 禁用选择
      // });
      this.getrlist();

      this.userCang = this.$utils.getlocalStorage("userCang").collegescore
      this.majorcangList = this.$utils.getlocalStorage("userCang").majorscore
    },

    methods: {
      getempty(str) {
        if (str == null || str == '') {
          return '--';
        }
        return str;
      },
      getscore(list,scoreYear) {
        let _this = this;
        let listr = []
        let ad = {
          scoreYear: "-",
          scorePlanNum: "-",
          scoreMin: "-",
          scoreMinRank: "-",
          scoreXiancha:'-'
        };
        if (list != null) {
          if (list.length < 3) {
            if(list.length == 2){
              if(list[0].scoreYear == scoreYear){
                listr.push(list[0])
                if(list[1].scoreYear == scoreYear-1){
                  listr.push(list[1])
                  listr.push(ad)
                } else {
                  listr.push(ad)
                  listr.push(list[1])
                }
              } else{
                listr.push(ad)
                listr.push(list[0])
                listr.push(list[1])
              }
            } else if (list.length == 1){
              if(list[0].scoreYear == scoreYear){
                listr.push(list[0])
                listr.push(ad)
                listr.push(ad)

              } else if(list[0].scoreYear == scoreYear-1){
                listr.push(ad)
                listr.push(list[0])
                listr.push(ad)
              } else if(list[0].scoreYear == scoreYear-2){
                listr.push(ad)
                listr.push(ad)
                listr.push(list[0])
              }
            }
          }  else{
            listr.push(list[0])
            listr.push(list[1])
            listr.push(list[2])
          }
        } else {
          listr.push(ad)
          listr.push(ad)
          listr.push(ad)
        }
        return listr;

      },
      getrlist() {
        this.rlist = this.$utils.getHeardrListfen(this.tianbaoType, this.typename)
      },
      search(obj) {
        let _this = this;
        if (this.typename != obj.typename) {
          this.typename = obj.typename
          this.userCang = this.$utils.getlocalStorage("userCang")[this.typename]
          this.getrlist()
        }
        this.batch = obj.batchname
        this.pickerValueArray.forEach(function(item){
          if(item.provincialBatch == obj.batchname){
            let obj = JSON.parse(item.spare1)
            if(obj.showcode == undefined){
              obj.showcode = false;
            }
            _this.$utils.setlocalStorage("showcode", obj.showcode)
          }
        })
        this.majorName = obj.majorname
        this.collegeName = obj.collegename
        this.pageNum = 1
        this.pages = 0
        this.data = []
        this.searchName()
        this.$refs.massage.getdata();
        this.getData()
      },
      getcangflag(id, ) {

      },
      searchMajor(obj) {
        this.collegeAreas = obj.collegeAreas
        this.collegeSubjection = obj.collegeSubjection
        this.collegeSubject = obj.collegeSubject
        this.collegeLevel = obj.collegeLevel
        this.majorInfo = obj.majorInfo
        this.collegeNature = obj.collegeNature
        // this.searchName()
        this.pageNum = 1
        this.pages = 0
        this.data = []
        this.$refs.massage.getdata();
        this.getData()
      },
      searchName() {
        this.showcrumbs = false
        this.$nextTick(() => (this.showcrumbs = true))
        this.collegeAreas = ''
        this.collegeLevel = ''
        this.collegeSubject = ''
        this.collegeSubjection = ''
        this.collegeNature = ''
        this.majorInfo = ''
      },
      getprovincialTable() {
        let _this = this;
        this.$req.queryAllbyFirstYear({
          provincialArea: this.scoreInfo.scoreArea,
          provincialSubject: this.scoreInfo.scoreSubject,
        }).then(function(response) {
          _this.pickerValueArray = response.data
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].provincialScore <= _this.scoreInfo.score) {
              _this.batch = response.data[i].provincialBatch
              _this.$utils.setlocalStorage("userZhiYuanBatch", _this.pickerValueArray[i])
              let obj = JSON.parse(response.data[i].spare1)
              if(obj.showcode == undefined){
                obj.showcode = false;
              }
              _this.$utils.setlocalStorage("showcode", obj.showcode)
              break;
            }
          }
          _this.$refs.massage.getdata();
          _this.getData();
        })
      },
      getData() {
        this.noMore =false;
        console.log('getdata')
        let _this = this;
        if (this.loadding) {
          return;
        }
        console.log('getdata========')
        if (this.pageNum == 1) {
          document.body.scrollTop = 0
        }
        if (this.typename == 'collegescore') {
          this.collegeAreas = ''
          this.collegeSubjection = ''
          this.collegeSubject = ''
          this.collegeLevel = ''
        }
        if (this.tianbaoType == 0) {
          if (this.typename == 'collegescore') {
            this.loadding = true;
            this.$req.queryScoreOldByCollege({
              pageNum: _this.pageNum,
              pageSize: _this.pageSize,
              queryObj: {
                collegeName: this.collegeName,
                majorName: this.majorName,
                scoretype: this.scoreInfo.scoreSubject,
                batch: this.batch,
                userScore: this.scoreInfo.score,
                userArea: this.scoreInfo.scoreArea,
                collegeAreas: this.collegeAreas,
                collegeSubjection: this.collegeSubjection,
                collegeSubject: this.collegeSubject,
                collegeLevel: this.collegeLevel,
                collegeNature: this.collegeNature,
                majorInfo: this.majorInfo,
              },
            }).then(function(response) {
              _this.loadding = false;
              if (response.status == '0') {
                _this.data = _this.data.concat(response.data)
                if(response.data.length == 0){
                  _this.noMore =true;
                }
                _this.pages = response.pages;
                if(response.dataAll){
                  _this.scoreYear = response.dataAll
                }
                _this.jhYear = response.year;
              }
            })
          } else {
            this.loadding = true;
            this.$req.queryScoreOldByMajor({
              pageNum: _this.pageNum,
              pageSize: _this.pageSize,
              queryObj: {
                collegeName: _this.collegeName,
                scoretype: _this.scoreInfo.scoreSubject,
                batch: _this.batch,
                userScore: _this.scoreInfo.score,
                userArea: _this.scoreInfo.scoreArea,
                majorName: _this.majorName,
                collegeAreas: _this.collegeAreas,
                collegeSubjection: _this.collegeSubjection,
                collegeSubject: _this.collegeSubject,
                collegeLevel: _this.collegeLevel,
                collegeNature: this.collegeNature,
                majorInfo: this.majorInfo,
              },
            }).then(function(response) {
              _this.loadding = false;
              if (response.status == '0') {
                _this.data = _this.data.concat(response.data)
                if(response.data.length == 0){
                  _this.noMore =true;
                }
                _this.pages = response.pages;
                if(response.dataAll){
                  _this.scoreYear = response.dataAll
                }
                _this.jhYear = response.year;
              }
            })
          }

        } else {
          this.loadding = true;
          let obj = {
            collegeName: this.collegeName,
            scoretype: this.scoreInfo.scoreSubject,
            batch: this.batch,
            userArea: this.scoreInfo.scoreArea,
            userScore: this.scoreInfo.score,
            majorName: this.majorName,
            collegeAreas: this.collegeAreas,
            collegeSubjection: this.collegeSubjection,
            collegeSubject: this.collegeSubject,
            collegeLevel: this.collegeLevel,
            tianbaoType: this.tianbaoType,
            showType: this.typename,
            collegeNature: this.collegeNature,
            majorInfo: this.majorInfo,
          }
          console.log(obj)
          this.$req.queryScoreByCollegeMajor({
            pageNum: _this.pageNum,
            pageSize: _this.pageSize,
            queryObj: obj,
          }).then(function(response) {
            _this.loadding = false;
            if (response.status == '0') {
              _this.data = _this.data.concat(response.data)
              _this.pages = response.pages;
              if(response.data.length == 0){
                _this.noMore =true;
              }
              if(response.dataAll){
                _this.scoreYear = response.dataAll
              }
              _this.jhYear = response.year;
            }
          })
        }

      },
      guanzhu(id, flag, type) {

        let _this = this;
        let flag1 = this.$utils.getLoginStatus();
        if (flag1) {
          let obj = this.$utils.getlocalStorage("userCang")
          let list = obj[this.typename]
          let majorlist = obj.majorscore
          if (!flag) {
            _this.$req.insert("collectionTable", {
              dataType: type == "collegescore" ? 3 : 4,
              dataId: id,
              userId:this.scoreInfo.userId
            }).then(function(resp) {
              if (resp.status == 0) {
                if (_this.typename == type) {
                  list.push(id);
                  _this.userCang = list;
                  obj[type] = list
                }
                if (type == 'majorscore') {
                  majorlist.push(id);
                  _this.majorcangList = majorlist;
                  obj[type] = majorlist
                }
                _this.$utils.setlocalStorage("userCang", obj);
              }
            })

          } else {
            _this.$req.batchDelete("collectionTable", {
              data_type: type == "collegescore" ? 3 : 4,
              data_id: id
            }).then(function(resp) {
              if (resp.status == 0) {
                if (_this.typename == type) {
                  list.splice(list.indexOf(id), 1);
                  _this.userCang = list
                  obj[type] = list
                }
                if (type == 'majorscore') {
                  majorlist.splice(majorlist.indexOf(id), 1);
                  _this.majorcangList = majorlist;
                  obj.majorscore = majorlist
                }
                _this.$utils.setlocalStorage("userCang", obj);
              }
            })
          }
        }
      },
      openMajor(index) {
        this.selectItemObj = this.data[index]
        this.isTrue = true;
      },
      zzc() {
        this.isTrue = true;
        console.log(this.isTrue);
      },
      zzcB() {
        this.isTrue = false;
      },
      showinfo(info) {
        if (info == null || info == '') {
          return '--';
        }
        return info;
      },
      handleScrollx() {
        if (this.$route.path == '/yuanxiaofen') {
          let tedItem = document.querySelector("#yuanshu1")
          let tedItem2 = document.querySelector("#yuanshu2")
          var scrollTop = tedItem.getBoundingClientRect().top
          var scrollTop2 = tedItem2.getBoundingClientRect().top
          let a = 100
          let b = 160
          if (this.typename != 'collegescore') {
            a = 200
            b = 400
          }

          if (scrollTop <= a) {
            this.guding = true
          }

          if (scrollTop2 >= b) {
            this.guding = false
          }
          const scrollY =
            document.body.scrollTop || document.documentElement.scrollTop; // 滚动条在Y轴上的滚动距离
          const compatibility =
            document.compatMode === "CSS1Compat" ?
            document.documentElement.clientHeight :
            document.body.clientHeight;
          // clientHeight 属性是一个只读属性，它返回该元素的像素高度，高度包含内边距（padding），不包含边框（border），外边距（margin）和滚动条，是一个整数，单位是像素 px。
          // 页面总高度
          const TotalHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight
          );
          // 当滚动条滑到页面底部
          if (compatibility + scrollY >= (TotalHeight - 1500)) {

            if (this.pageNum < this.pages && !this.loadding) {
              this.pageNum++;
              this.getData()
            } else {
              if(this.pages == 0){
                this.noMore =true;
              }
            }
          }
        }

      },

      //===========================点击展开关闭效果====================================
      openShutManager(oSourceObj, oTargetObj, shutAble, oOpenTip, oShutTip) {
        var sourceObj = typeof oSourceObj == "string" ? document.getElementById(oSourceObj) : oSourceObj;
        var targetObj = typeof oTargetObj == "string" ? document.getElementById(oTargetObj) : oTargetObj;
        var openTip = oOpenTip || "";
        var shutTip = oShutTip || "";
        if (targetObj.style.display != "none") {
          if (shutAble) return;
          targetObj.style.display = "none";
          if (openTip && shutTip) {
            sourceObj.innerHTML = shutTip;
          }
        } else {
          targetObj.style.display = "block";
          if (openTip && shutTip) {
            sourceObj.innerHTML = openTip;
          }
        }
      },

    },

  };
</script>
<style scoped>
  /* .two {
    display: flex;
    width: 100%;
    height: 100px;
    background-color: #f66464;
    margin-top: 20px;
    border-radius: 2px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 50px;
    color: #ffffff;
    justify-content: center;
    align-items: center;
  } */

  .btn {
    padding: 0;
  }

  .test {
    width: 200px !important;
  }

  /* 改动中间 */
  .two_A div {
    color: #ffffff;
  }

  .ANAN::-webkit-scrollbar {
    width: 14px;
    height: 746px;
    background: rgba(246, 246, 246, 1);
    opacity: 1;
  }

  .ANAN::-webkit-scrollbar-thumb {
    width: 8px;
    height: 151px;
    background: rgba(245, 56, 36, 1);
    opacity: 1;
    border-radius: 4px;
  }

  .Cont9_B p {
    color: #ffffff;
  }

  /* 改动中间 */
  .two .T_title1 {
    width: 21%;
    text-align: center;
  }

  .two .T_title2 {
    width: 6%;
    text-align: center;
  }

  .two .T_title3 {
    width: 6%;
    text-align: center;
  }

  .two .T_title4 {
    width: 8%;
    text-align: center;
  }

  .two .T_title5 {
    width: 8%;
    text-align: center;
  }

  .two .T_title6 {
    width: 8%;
    text-align: center;
  }

  .two .T_title7 {
    width: 8%;
    text-align: center;
  }

  .two .T_title8 {
    width: 27%;
    text-align: center;
    display: flex;
    flex-direction: column;
    border-left: 1px solid rgba(255, 255, 255, 0.3);
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title8top {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title8bot {
    display: flex;
    justify-content: space-evenly;
  }

  .two .T_title9 {
    width: 8%;
    text-align: center;
  }


  .container {
    width: 1280px;
  }


  /* 中间内容 */
  .three {
    width: 100%;
    height: auto;
    margin-top: 11px;
    margin-bottom: 55px;
    min-height: 300px;
  }

  .three .three_for {
    display: flex;
    width: 100%;
    height: auto;
    border: 1px solid #c0c4cc;
    border-radius: 10px;
    margin-top: 18px;

  }

  .three .Cont1 {
    width: 20%;
    height: auto;
    display: flex;
    /* padding-top: 15px; */
    padding-left: 15px;
    align-items: center;
    box-sizing: border-box;
  }

  .three .Cont {
    border-right: 1px solid #ebe9e9;
  }

  .three .Cont2 {
    width: 5%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 32px;
  }

  .three .Cont3 {
    width: 5%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 32px;
  }

  .three .Cont4 {
    width: 8%;
    height: auto;
    display: flex;
    align-items: center;

    justify-content: center;
    text-align: center;
    line-height: 30px;
  }

  .three .Cont5 {
    width: 5%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 32px;
  }

  .three .Cont6 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14%;
    height: auto;
    text-align: center;
    cursor: pointer;
  }

  .three .Cont7 {
    width: 5%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 32px;
  }

  .three .Cont8 {
    width: 24%;
    height: auto;
    display: flex;
    flex-direction: column;
  }

  .scoreInfo {
    display: flex;
    width: auto;
    flex-direction: row;
    justify-content: space-between;
    height: 33.33%;

  }

  .Cont8_A {
    width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    border-right: 1px solid #ebe9e9;
  }

  .Cont8_AA {
    height: 33.33%;
    display: flex;
    flex-direction: row;
    width: 100%;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29a7e1;
  }

  .Cont8_B {
    width: 20%;
    height: 100%;
    line-height: 100%;
    border-bottom: 1px solid #ebe9e9;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .three .Cont9 {
    width: 8%;
    height: auto;
    text-align: center;
    line-height: 32px;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .three .Cont10 {
    width: 6%;
    height: auto;
    text-align: center;
    line-height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Cont9 .Cont9_A {
    display: flex;
    justify-content: center;
    width: 92px;
    height: 36px;
    border: 1px solid #f66464;
    border-radius: 10px;
    color: #f66464 !important;
    align-items: center;
    cursor: pointer;
  }

  /* 点击关注 切换 */
  .Cont9 .Cont9_B {
    display: flex;
    justify-content: center;
    width: 92px;

    height: 36px;
    background-image: url('../../src/assets/img/yiguanzhu.png');
    background-size: 92px 36px;
    align-items: center;
    cursor: pointer;
  }

  .Cont9_B p {
    color: #ffffff !important;
  }

  .Cont9_A img {
    width: 15px;
    height: 16px;
    margin-right: 8px;
  }

  .Cont9_A p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 20px;
    color: #f6461e;
  }

  .Cont_img {
    width: 110px;
    height: 110px;
  }

  /* .Cont_Nr {
    flex: 1;
  }

  .Cont_Nr p {
    font-size: 18px;
    font-family: MicrosoftYaHei;
    line-height: 20px;
    color: #29a7e1;
  }

  .Cont_Card {
    margin-top: 12px;
  }

  .Cont_Card span {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 7px;
    color: #333333;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #e8e8e8;
    padding: 6px 10px;
    margin-right: 12px;
    margin-top: 0px;
    display: inline-block;
    word-wrap: break-word;
    overflow: hidden;
    white-space: pre-wrap;
  } */

  .Cont_TP {
    display: flex;
    flex-direction: column;
  }

  .Cont_TP img {
    width: 68px;
    height: 68px;
  }

  .Cont_TP p {
    display: block;
    width: 68px;
    height: 28px;
    background: rgba(242, 242, 242, 0.39);
    border-radius: 5px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 20px;
    color: #F53824;
    text-align: center;
    line-height: 28px;
    margin-top: 0px;
  }

  .Cont_Nr {
    flex: 1;
    margin-left: 14px;
  }

  .Cont_Nr p {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
  }

  .Cont_Card {
    margin-top: 12px;
  }

  .Cont_Card span {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 18px;
    color: #333333;
    opacity: 1;
  }





  .three_for .Cont2 p {
    font-size: 16px;
    font-family: MicrosoftYaHei;
  }

  .Cont6 .btn {
    width: 92px;
    height: 36px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #29a7e1;
    color: #29a7e1;
    text-align: center;
    opacity: 1;
    border-radius: 5px;
    line-height: 36px;
    font-size: 16px;
  }

  .Cont6 .Cont2_top {
    width: 100%;
    padding-left: 10px;
    text-align: left;
  }

  .Cont6 .Cont2_top p {
    width: 100%px;
    margin-top: 3px;
    /* height: 36px; */
    color: #777777;
    text-align: left;
    line-height: 18px;
    font-size: 16px;
  }



  .three_for .Cont3 p,
  .three_for .Cont4 p,
  .three_for .Cont5 p,
  .three_for,
  .three_for .Cont7 p {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #333333;
  }

  /* 遮罩层  ↓ */
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 844;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .maskA {
    width: 910px;
    height: 90vh;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 910px;
    height: 64px;
    background-image: url("../../src/assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    box-sizing: border-box;
    margin-bottom: 10px;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANAN {
    width: 100%;
    height: calc(100% - 90px);
    padding: 0;
    overflow-y: scroll;
  }

  .maskAA p {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .two_A {
    width: 850px;
    height: 46px;
    background: #f66464;
    border-radius: 5px;
    display: flex;
    align-items: center;
    margin: auto;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    opacity: 1;
  }

  .T_title1_A {
    width: 38%;
    text-align: center;
    line-height: 46px;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title8_A {
    width: 46%;
    text-align: center;
    line-height: 46px;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title9_A {
    width: 16%;
    text-align: center;
    line-height: 46px;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title8bot_A {
    display: flex;
    justify-content: space-evenly;
  }

  .three_A {
    width: 850px;
    height: auto;
    margin: auto;
    margin-top: 11px;
    padding-bottom: 64px;
    box-sizing: border-box;
  }

  .three_for_A {
    display: flex;
    width: 100%;
    height: auto;
    border: 1px solid #ebe9e9;
    border-radius: 10px;
    margin-top: 11px;
  }

  .Cont_A {
    border-right: 1px solid #ebe9e9;
  }

  .Cont1_A {
    width: 38%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 14px;
    padding-left: 30px;
    box-sizing: border-box;
  }

  .Cont1_A .Cont_Nr_A h3 {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 20px;
    color: #29a7e1;
    margin-bottom: 10px;
  }

  .Cont_Nr_A p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 24px;
    color: #666666;
  }

  .Cont8_S {
    width: 46%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: ;
    border: none;

  }

  .Cont9_S {
    width: 16%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
  }

  .Cont9_S .Cont9_AAA {
    display: flex;
    justify-content: center;
    width: 92px;
    height: 36px;
    background-image: url("../../src/assets/img/weiguanzhu.png");
    background-size: 92px 36px;
    align-items: center;
    cursor: pointer;
  }

  /* 点击关注 切换 */
  .Cont9_S .Cont9_BBB {
    display: flex;
    justify-content: center;
    width: 92px;
    height: 36px;
    background-image: url('../../src/assets/img/yiguanzhu.png');
    background-size: 92px 36px;
    align-items: center;
    cursor: pointer;
  }

  .Cont9_BBB p {
    color: #FFFFFF !important;
  }

  .Cont9_AAA img {
    width: 15px;
    height: 16px;
    margin-right: 8px;
  }

  .Cont9_AAA p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 20px;
    color: #666666;
  }

  /* @media (max-width:750px) {
    .query {
      flex-direction: column;
      margin-top: 40px;
      margin-bottom: 55px;
    }

    .query_top {
      margin-top: 10px;
    }

    .query_top input {
      width: 220px;
    }

    .query_bot {
      margin-top: 10px;
      line-height: 37px;
    }

    .two {
      width: 1500px;
    }

    .tablecon {
      overflow: auto;
    }

    .three {
      width: 1500px;
    }

    .maskA {
      width: 80%;
      height: 80%;
    }

    .maskAA {
      width: 100%;
    }

    ::-webkit-scrollbar {
      display: none;
    }
  } */

  /* @media (max-width:980px) {
    .two {
      width: 1500px;
    }

    .tablecon {
      overflow: auto;
    }

    .three {
      width: 1500px;
    }

    .maskA {
      width: 80%;
      height: 80%;
    }

    .maskAA {
      width: 100%;
    }

    ::-webkit-scrollbar {
      display: none;
    }
  } */

  /* @media (max-width:1400px) {
    .two {
      width: 1500px;
    }

    .tablecon {
      overflow: auto;
    }

    .three {
      width: 1500px;
    }

    .maskA {
      width: 90%;
      height: 85%;
    }

    .maskAA {
      width: 100%;
    }

    ::-webkit-scrollbar {
      display: none;
    }
  } */
</style>



// WEBPACK FOOTER //
// src/views/yuanxiaofen.vue